class PrintController {
    /*@ngInject*/
    constructor($translate) {
        this.$translate = $translate;
        this.model = {
            bagout: null
        };
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.model.branchCoinReport = window.opener.w.printData;
            this.print();
        }
    }

    print() {
        setTimeout(() => {
            window.print();
        }, 1500)
    }
}
export default PrintController;


// WEBPACK FOOTER //
// ./client/app/components/coin_pull_report/print_branch_coin/print_branch_coin.controller.js